<div class="pdf-page app-ilp-001-01-04" id="ilp010104">
  <div class="t-right p-5">
    <p class="font-small"><b>IL P 001 01 04</b></p>
  </div>
  <p class="font-large mb-0" style="text-align: center">
    <b>U.S. TREASURY DEPARTMENT'S OFFICE OF FOREIGN</b>
  </p>
  <p class="font-large mb-0" style="text-align: center">
    <b>ASSETS CONTROL ("OFAC")</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>ADVISORY NOTICE TO POLICYHOLDERS</b>
  </p>

  <p class="font-small">
    No coverage is provided by this Policyholder Notice nor can it be construed
    to replace any provisions of your policy. You should read your policy and
    review your Declarations page for complete information on the coverages you
    are provided.
  </p>

  <p class="font-small">
    This Notice provides information concerning possible impact on your
    insurance coverage due to directives issued by OFAC.<b>
      Please read this Notice carefully.</b
    >
  </p>

  <p class="font-small">
    The Office of Foreign Assets Control (OFAC) administers and enforces
    sanctions policy, based on Presidential declarations of "national
    emergency". OFAC has identified and listed numerous:
  </p>

  <ul class="font-small">
    <li>Foreign agents;</li>
    <li>Front organizations;</li>
    <li>Terrorists;</li>
    <li>Terrorist organizations; and</li>
    <li>Narcotics traffickers;</li>
  </ul>

  <p class="font-small">
    as "Specially Designated Nationals and Blocked Persons". This list can be
    located on the United States Treasury's web site - http//www.treas.gov/ofac
  </p>

  <p class="font-small">
    In accordance with OFAC regulations, if it is determined that you or any
    other insured, or any person or entity claiming the benefits of this
    insurance has violated U.S. sanctions law or is a Specially Designated
    National and Blocked Person, as identified by OFAC, this insurance will be
    considered a blocked or frozen contract and all provisions of this insurance
    are immediately subject to OFAC. When an insurance policy is considered to
    be such a blocked or frozen contract, no payments nor premium refunds may be
    made without authorization from OFAC. Other limitations on the premiums and
    payments also apply.
  </p>
</div>
